import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./DisplaySectionContent.module.css";
import TextSectionElement from "../TextSectionElement";
import ImageSectionElement from "../ImageSectionElement";
import DividerSectionElement from "../DividerSectionElement";
import MediaSectionElement from "../MediaSectionElement";
import CMSSectionElement from "../CMSSectionElement";
import BSMSectionElement from "../BSMSectionElement";

/**
 * View component. Displays a feed item’s contents (sections).
 */
export function DisplaySectionContent({ sectionElements, isHidden }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {}, [sectionElements]);

  return (
    <div
      style={{ display: isHidden ? "none" : "block" }}
      className={styles.container}
    >
      {sectionElements.map((sections, index) => {
        {
          if (sections.elements && !sections.hidden) {
            return (
              <div
                key={sections.id || index} // Update with key to prevent warnings
                style={{ backgroundColor: sections.backgroundColor }}
              >
                {sections.elements.map((section, index) => {
                  switch (section.type) {
                    case "text":
                      return (
                        <div
                          className={styles.padding}
                          key={section.id || index} // Update with key to prevent warnings
                        >
                          <TextSectionElement
                            text={section.text}
                            align={section.alignment}
                            textColor={section.textColor}
                            width={section.width}
                            size={section.size}
                          />
                        </div>
                      );
                    case "divider":
                      return (
                        <div
                          className={styles.padding}
                          key={section.id || index} // Update with key to prevent warnings
                        >
                          <DividerSectionElement
                            dividerColor={
                              section.color ? section.color : "black"
                            }
                          />
                        </div>
                      );
                    case "image":
                      const currentPhoto = section.currentPhoto
                        ? section.currentPhoto
                        : {
                            alignment: section.alignment,
                            src: section.path,
                            link: section.link,
                          };
                      return (
                        <div
                          className={styles.paddingPhoto}
                          key={section.id || index} // Update with key to prevent warnings
                        >
                          <ImageSectionElement currentPhoto={currentPhoto} />
                        </div>
                      );
                    case "media":
                      const elementMediaSettings = {
                        header: section?.title?.text ?? "",
                        headerColor: section?.title?.color ?? "default",
                        id: section?.id ?? "",
                        buttonColor: section?.buttonColor,
                        format: section?.format,
                      };
                      return (
                        <div
                          className={styles.padding}
                          key={section.id || index} // Update with key to prevent warnings
                        >
                          <MediaSectionElement
                            isModalOpen={isOpen}
                            setIsModalOpen={() => setIsOpen(!isOpen)}
                            mediaSettings={
                              section.mediaSettings || elementMediaSettings
                            }
                          />
                        </div>
                      );
                    //Still can't see what actual cms or bsm items look like
                    case "cms":
                      return (
                        <div
                          className={styles.padding}
                          key={section.id || index} // Update with key to prevent warnings
                        >
                          <CMSSectionElement cmsItem={section.cmsItem} />
                        </div>
                      );
                    case "bsm":
                      return (
                        <div
                          className={styles.padding}
                          key={section.id || index} // Update with key to prevent warnings
                        >
                          <BSMSectionElement bsmItem={section.bsmItem} />
                        </div>
                      );

                    default:
                      return null;
                  }
                })}
              </div>
            );
          } else {
            let content = null;
            switch (sections.type) {
              case "text":
                content = (
                  <div className={styles.padding} key={index}>
                    <TextSectionElement
                      text={sections.text}
                      align={sections.alignment}
                      textColor={sections.textColor}
                      width={sections.width}
                      size={sections.size}
                    />
                  </div>
                );
                break;
              case "divider":
                content = (
                  <div className={styles.padding}>
                    <DividerSectionElement
                      dividerColor={sections.color ? sections.color : "black"}
                    />
                  </div>
                );
                break;
              case "image":
                const currentPhoto = {
                  src: sections.path,
                  alignment: sections.alignment,
                  link: sections.link,
                };
                content = (
                  <div className={styles.paddingPhoto}>
                    <ImageSectionElement currentPhoto={currentPhoto} />
                  </div>
                );
                break;
              case "media":
                const mediaSettings = {
                  header: sections.title.text,
                  headerColor: sections.title.color
                    ? sections.title.color
                    : "default",
                  id: sections.id,
                  buttonColor: sections.buttonColor,
                  format: sections.format,
                };
                content = (
                  <div className={styles.padding}>
                    <MediaSectionElement
                      isModalOpen={isOpen}
                      setIsModalOpen={() => setIsOpen(!isOpen)}
                      mediaSettings={mediaSettings}
                    />
                  </div>
                );
                break;
              case "cms":
                content = (
                  <div className={styles.padding}>
                    <CMSSectionElement cmsItem={sections.cmsItem} />
                  </div>
                );
                break;
              case "bsm":
                content = (
                  <div className={styles.padding}>
                    <BSMSectionElement bsmItem={sections.bsmItem} />
                  </div>
                );
                break;
              default:
                content = null;
            }
            return (
              <div
                key={sections.id || index} // Update with key to prevent warnings
                style={{ backgroundColor: sections.backgroundColor }}
              >
                {content}
              </div>
            );
          }
        }
      })}
    </div>
  );
}

DisplaySectionContent.propTypes = {
  sectionElements: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf([
        "text",
        "image",
        "divider",
        "media",
        "cms",
        "bsm",
      ]),
    })
  ),
  isHidden: PropTypes.bool,
};
